import React from 'react'
import Qualityviewfile from '../../components/qualityreportcomponents/Qualityviewfile'


function  Qualityview({renderPageContent}) {
    return (
        <>
                        <Qualityviewfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Qualityview
